import type { ReactNode } from 'react'

import { Icon } from './Icon'

/**
 * `top-bar` — 40 screens (design-spec.md §5.1). 84 high, or 92 on KYC and
 * sheet headers. In RTL the back button sits on the **left** and the title on
 * the right, so the row is laid out with the title first in source order.
 */
interface TopBarProps {
  title?: string
  onBack?: () => void
  /** KYC and sheet headers are 92 high instead of 84. */
  tall?: boolean
  /** Optional trailing control — the menu or dots button in the variants. */
  action?: ReactNode
}

export function TopBar({ title, onBack, tall = false, action }: TopBarProps) {
  return (
    <header
      className="sx-col-app flex w-full shrink-0 items-center"
      style={{ height: tall ? 'var(--sx-topbar-h-kyc)' : 'var(--sx-topbar-h)' }}
    >
      {/* RTL puts the first child on the right, so title then back button
          is already title-right / back-left — no reversal needed. */}
      <div className="flex h-[52px] w-full items-center justify-between">
        {/* 37px line box, which is what centres the title on the design's y. */}
        {title ? (
          <h1 className="text-24 leading-[37px] font-bold text-ink">{title}</h1>
        ) : (
          <span />
        )}

        <div className="flex items-center gap-2">
          {action}
          {onBack ? (
            <button
              type="button"
              onClick={onBack}
              aria-label="بازگشت"
              className="flex size-[44px] items-center justify-center rounded-10 bg-surface-5 text-ink"
            >
              {/* The design draws a left-pointing arrow here even in RTL
                  (`202:3867` and every KYC frame), so it is not mirrored. */}
              <Icon name="arrow-left" size={18} />
            </button>
          ) : null}
        </div>
      </div>
    </header>
  )
}
